import React from 'react';
import CustomModel from 'components/Model/CustomModel';
import XmlInput from 'components/Input/XmlInput';
import { useDocumentToJsonMutation } from 'reducers/Document.service';
import { useBulkInviteRealtorMutation , useGetBulkInvitedRealtorsQuery } from 'reducers/realtor.service';
import { REALTOR_TYPE , LENDER_TYPE } from 'constants/index';

export default function BulkInviteModel({ open ,setopen, setfile, file, selectedType = REALTOR_TYPE }) {
    const [uploadFile, { isLoading: uploadLoading, data: documentData }] = useDocumentToJsonMutation();
    const [bulkInvite, { isLoading: inviteLoading }] = useBulkInviteRealtorMutation();
    const { refetch } = useGetBulkInvitedRealtorsQuery(selectedType);

    const handleRemove = ()=>{
        setfile(null);
    };
    const handleFile = (file)=>{
        if (file) {
            const formdata = new FormData();
            formdata.append('file', file);
            setfile(file);
            uploadFile({ body: formdata , USERTYPE: selectedType }).unwrap().catch(()=>{
                setfile(null);
            });
        } else {
            // else check the file
        }
    };
    const handleInvite = ()=>{
        setopen(!open);
        setfile(null);
    };

    const handleSuccess = ()=>{
        bulkInvite({ body: documentData?.data , USERTYPE: selectedType }).unwrap().then(()=>{
            handleInvite();
            refetch();
        });
    };

    return (
        <CustomModel
            title={selectedType === LENDER_TYPE ? 'Add Multiple Lender' : 'Add Multiple Realtor '}
            isOpen={open}
            setisOpen={handleInvite}
            disabled={documentData?.data?.length <= 0 || !file}
            isLoading ={inviteLoading || uploadLoading}
            handleSuccess={handleSuccess}
            successLabel ={selectedType === LENDER_TYPE ? 'Add Lender' : 'Add Realtor' }
        >
            <XmlInput
                handleRemove={handleRemove}
                required={true}
                isLoading = { uploadLoading}
                lable="We only support .xlsx or .csv files."
                title="Please select excel or csv to start uploading."
                setfile={handleFile}
                file={file}
                selectedType={selectedType}
                data={documentData?.data}
                errors={documentData?.errors}
            />
        </CustomModel>

    );
}
